<template>
  <div
    :class="{ 'has-errors': hasErrors, 'mb-4': addBottomMargin, changed }"
    class="block"
    data-cy="date-picker">
    <label
      v-if="label.length"
      :for="inputId"
      :class="labelClass"
      class="control-label mb-2 flex">
      <span v-html="label"></span>
      <span
        v-if="required"
        class="text-red">
        *
      </span>
    </label>
    <v-date-picker
      :id="inputId"
      v-model:value="localDate"
      :type="type"
      :append-to-body="false"
      :lang="lang"
      :clearable="!!modelValue"
      :disabled-date="disabledDate"
      :value-type="valueType"
      :input-class="['form-control', { bordered }]"
      :input-attr="inputAttr"
      :formatter="formatter"
      :show-second="false"
      :placeholder="placeholder">
      <template #icon-calendar>
        <svg-icon
          data-cy="calendar-icon"
          name="calendar"
          width="15"
          height="16" />
      </template>
      <template #icon-clear>
        <svg-icon
          name="close"
          width="14"
          height="14" />
      </template>
    </v-date-picker>
    <span
      v-if="hasErrors"
      class="error-box mt-2">
      {{ inputErrors.join(", ") }}
    </span>
    <slide-transition>
      <p
        v-if="explanation.length"
        class="typeset-9 text-ink-4 my-3">
        {{ explanation }}
      </p>
    </slide-transition>
  </div>
</template>

<script>
import VDatePicker from "vue-datepicker-next";
import "vue-datepicker-next/index.css";

import SlideTransition from "../transitions/SlideTransition.vue";
import SvgIcon from "./SvgIcon.vue";

export default {
  name: "DatePicker",
  components: {
    VDatePicker,
    SlideTransition,
    SvgIcon
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "Select date"
    },
    inputId: {
      type: String,
      required: true,
      default: ""
    },
    errors: {
      type: Array,
      default: () => []
    },
    explanation: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      required: false,
      default: "typeset-6"
    },
    lang: {
      type: String,
      default: "en"
    },
    disabledDate: {
      type: Function,
      default: () => false
    },
    inputAttr: {
      type: Object,
      default: () => {}
    },
    formatter: {
      type: [String, Object],
      default: "YYYY-MM-DD"
    },
    valueType: {
      type: String,
      default: "format"
    },
    type: {
      type: String,
      default: "date"
    },
    bordered: {
      type: Boolean,
      default: false
    },
    changed: {
      type: Boolean,
      default: false
    },
    addBottomMargin: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue"],
  computed: {
    inputErrors() {
      return this.errors || [];
    },
    hasErrors() {
      return this.inputErrors.length > 0;
    },
    localDate: {
      get() {
        return this.modelValue;
      },
      set(localDate) {
        this.$emit("update:modelValue", localDate);
      }
    }
  }
};
</script>

<style>
.changed {
  border: 2px solid var(--orange);
  margin: -2px;
}
</style>
